import styled from "styled-components";

export const SubTitle = styled.div`
	margin: 4px;
	border-bottom: 1px solid #ddd;
	padding: 6px;
	width: 100%;
`;
